import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { editMutations } from './types';
import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	CasJdnPoc: null as number | null,
	DphSzbOzn: null as number | null,
	EmisePzn: null as number | null,
	EditPrp: null as number | null,
	CinnostPrp: null as number | null,
	PcPevna: null as number | null,
	PcSpec: null as number | null,
	ZaznamId: null as number | null,
	ZarmobilPzn: null as number | null,
	StrnakltypOzn: null as number | null,
	PpNr: null as number | null,
	VstupDat: null as string | null,
	Text: null as string | null,
	LakJdnPoc: null as number | null,
	Tablpozice: null as number | null,
	TablpoziceText: null as number | null,
	VyrobekvozOzn: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
		DphSzbOzn: [],
		ZarmobilPzn: [],
		StrnakltypOzn: [],
		EmisePzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.PRACOVNI_POZICE_TABULKOVA_POZICE_SELECT_MAPPER](state, { data }) {
			state.edit.Tablpozice = data.value;
			state.edit.TablpoziceText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
